import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RolModel } from 'src/app/model/rol.model';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getAll = () => {
    return this.http.get(`${this.url}/rol/List`)
      .pipe(map((resp: any) => resp));
  }

  getById = (iRolId: number) => {
    return this.http.get(`${this.url}/rol/findByRol/${iRolId}`)
      .pipe(map((resp: any) => resp));
  }

  create = (rol: RolModel) => {
    return this.http.post(`${this.url}/rol/create`, rol)
      .pipe(map((resp: any) => resp));
  }

  update = (rol: RolModel) => {
    return this.http.post(`${this.url}/rol/update`, rol)
      .pipe(map((resp: any) => resp));
  }
}
